import React from 'react'

import ModalBody from 'components/Utils/Modal/Body'
import ModalWrapper from 'components/Utils/Modal/Wrapper'

import { useDispatch } from 'react-redux'
import { goToOrganizationUpgrade } from 'data/ui/actions'
import Illustration from './IncentiveIllustration.png'
import { Button, Text } from '../../base'

export type EditProtectionIncentiveModalProps = {
  onModalClose: () => void
}

export default function EditProtectionIncentiveModal({
  onModalClose,
}: EditProtectionIncentiveModalProps) {
  const dispatch = useDispatch()

  const handleGoToUpgrade = () =>
    dispatch(goToOrganizationUpgrade({ incentiveId: 'EditProtection' }))

  return (
    <ModalWrapper preventClose size={400} onModalClose={onModalClose}>
      <ModalBody style={{ padding: 0 }}>
        <div className="slite-design-system">
          <img
            alt="incentive-illustratioon"
            src={Illustration}
            style={{ pointerEvents: 'none' }}
          />
          <div className="background-shade-100 padding-vertical-larger padding-horizontal-large flexbox flexbox-column flexbox-align-center center-text">
            <Text.Title>Prevent unwanted edits</Text.Title>
            <Text.Detail className="margin-vertical-large line-height-larger">
              <span className="shade-05 font-size-normal">
                Your team could protect some docs from accidental or further
                edits. Upgrade to enable this feature.
              </span>
            </Text.Detail>
            <Button.Primary
              className="margin-vertical-small"
              onClick={handleGoToUpgrade}
            >
              Upgrade
            </Button.Primary>

            <Text.SmallDetail
              onClick={onModalClose}
              className="underline pointer padding-top-large"
            >
              or upgrade later
            </Text.SmallDetail>
          </div>
        </div>
      </ModalBody>
    </ModalWrapper>
  )
}
